"use strict";

export default [
  "$scope",
  "$location",
  "$routeParams",
  "AppealsRestService",
  "OrgService",
  "StaffService",
  "Notification",
  "MunicipalityRestService",
  function (
    $scope,
    $location,
    $routeParams,
    AppealsRestService,
    OrgService,
    StaffService,
    Notification,
    MunicipalityRestService
  ) {
    // Добавляем $routeParams в scope
    console.log("routeParams", $routeParams);
    $scope.routeParams = $routeParams;

    $scope.formData = {
      reason: "land", // Default reason set to 'land'
      investment: 0,
      workplaces: 0,
    };
    $scope.municipalities = [];
    $scope.categories = [];
    $scope.statuses = [];
    $scope.responsibles = [];
    $scope.organizations = [];

    // Add reason selection handling
    $scope.setReason = function (reason) {
      $scope.formData.reason = reason;
    };

    // Update organization selection modal to use OrgService
    $scope.addOrg = function () {
      OrgService.select($scope.formData.author, {}) // Add filters if needed
        .result.then(function (org) {
          $scope.formData.author = org;
        });
    };

    // Update manager selection modal to use StaffService
    $scope.addManager = function () {
      StaffService.select($scope.formData.manager, {}) // Add filters if needed
        .result.then(function (manager) {
          $scope.formData.manager = manager;
        });
    };

    init();

    function init() {
      MunicipalityRestService.get({
        filters: [`'status' EQ 'ENABLED'`],
        sorts: ["npp:ASC", "name:ASC"],
      }).$promise.then(function (response) {
        $scope.municipalities = response._embedded;

        console.log("municipalities", $scope.municipalities);
      });

      if ($routeParams.id) {
        loadAppeal($routeParams.id);
      }
    }

    function loadAppeal(id) {
      AppealsRestService.get({ treatmentId: id })
        .$promise.then((response) => {
          const data = response._embedded;

          $scope.formData = {
            id: data.id,
            reason:
              data.type === "place"
                ? "land"
                : data.type === "support"
                ? "support"
                : "maintenance",
            shortName: data.shortName,
            fullName: data.name,
            investment: data.investments,
            workplaces: data.workplaces,
            managerId: data.manager?.id,
            organization: data.author?.id,

            // Convert dates from "DD.MM.YYYY" format to Date objects
            sentDate: data.investorSendDate
              ? new Date(data.investorSendDate.split(".").reverse().join("-"))
              : null,
            responseDate: data.feedbackDate
              ? new Date(data.feedbackDate.split(".").reverse().join("-"))
              : null,

            // Contact information
            contactName: data.accessorName,
            contactPosition: data.accessorGrade,
            contactEmail: data.accessorMail,
            contactPhone: data.accessorPhone,

            author: data.author,
            manager: data.manager,

            // Municipality will need to be set once municipalities are loaded
            municipalities: data.placesMunicipality,
          };

          console.log("formData", $scope.formData);
        })
        .catch(function (error) {
          console.error("Error loading appeal:", error);
        });
    }

    $scope.resetManagerFilter = function () {
      $scope.formData.manager = null;
    };

    $scope.resetOrgFilter = function () {
      $scope.formData.author = null;
    };

    $scope.save = function () {
      if ($scope.appealForm.$invalid) {
        return;
      }

      // Create copy of formData to avoid modifying the view
      const dataToSave = angular.copy($scope.formData);

      // Create the form object structure expected by backend
      const requestData = {
        form: {
          type:
            dataToSave.reason === "land"
              ? "place"
              : dataToSave.reason === "support"
              ? "support"
              : "maintenance",
          shortName: dataToSave.shortName,
          name: dataToSave.fullName,
          investments: dataToSave.investment,
          workplaces: dataToSave.workplaces,
          manager: dataToSave.manager?.id,
          author: dataToSave.author?.id,
          municipalities: dataToSave.municipalities?.length
            ? dataToSave.municipalities.map((item) => item.id)
            : [],

          // Convert dates to DD.MM.YYYY format
          investorSendDate: dataToSave.sentDate
            ? formatDate(dataToSave.sentDate)
            : null,
          feedbackDate: dataToSave.responseDate
            ? formatDate(dataToSave.responseDate)
            : null,

          // Contact information
          accessorName: dataToSave.contactName,
          accessorPhone: dataToSave.contactPhone,
          accessorMail: dataToSave.contactEmail,
          accessorGrade: dataToSave.contactPosition,
        },
      };

      // Используем разные методы для создания и обновления
      const promise = $routeParams.id
        ? AppealsRestService.update({ id: dataToSave.id }, requestData).$promise
        : AppealsRestService.create(requestData).$promise;

      promise.then(
        function () {
          Notification.success({
            title: "Успешно!",
            message: $routeParams.id
              ? "Обращение сохранено"
              : "Обращение создано",
          });

          if (!$routeParams.id) {
            $location.path("/primary-appeals");
          }
        },
        function (error) {
          Notification.warning({
            title: "Внимание!",
            message: $routeParams.id ? "Ошибка сохранения" : "Ошибка создания",
          });
          console.error("Save error:", error);
        }
      );
    };

    // Helper function to format date as DD.MM.YYYY
    function formatDate(date) {
      if (!date) return null;
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    }

    $scope.cancel = function () {
      $location.path("/primary-appeals");
    };

    $scope.remove = function () {
      AppealsRestService.remove({ id: $scope.formData.id }).$promise.then(
        function () {
          Notification.success({
            title: "Успешно!",
            message: "Обращение удалено",
          });
          $location.path("/primary-appeals");
        },
        function (error) {
          Notification.warning({
            title: "Внимание!",
            message: "Ошибка удаления",
          });
          console.error("Delete error:", error);
        }
      );
    };

    // Add filter function for ui-select
    $scope.propsFilter = function (props, search) {
      var out = [];

      if (angular.isArray(props)) {
        props.forEach(function (item) {
          var itemNameMatch =
            String(item.name)
              .toLowerCase()
              .indexOf(search || "") !== -1;
          if (itemNameMatch) out.push(item);
        });
      }
      return out;
    };
  },
];
